import { render, staticRenderFns } from "./CustomerVoicePostCreate.vue?vue&type=template&id=b1dbe32c&"
import script from "./CustomerVoicePostCreate.vue?vue&type=script&lang=js&"
export * from "./CustomerVoicePostCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports